import React from 'react'
import {
  Wrap,
  WrapItem,
  Input,
  FormControl,
  FormLabel,
} from '@chakra-ui/react'

const DateInput = ({ label, ...props }) => (
  <WrapItem>
    <FormControl>
      <FormLabel fontSize="sm">{label}</FormLabel>
      <Input type="date" {...props} />
    </FormControl>
  </WrapItem>
)

const DateRange = ({ value, name, onChange }) => {
  return (
    <Wrap>
      <DateInput label="起始日期" name={`${name}.start`} onChange={onChange} value={value?.start} />
      <DateInput label="結束日期" name={`${name}.end`} onChange={onChange} value={value?.end} />
    </Wrap>
  )
}

export default DateRange
